import { render, staticRenderFns } from "./RequestPartnershipDetailModal.vue?vue&type=template&id=4bd512a6&"
import script from "./RequestPartnershipDetailModal.vue?vue&type=script&lang=js&"
export * from "./RequestPartnershipDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports